import { Img } from "components";
import { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CSSProperties } from "react";
import Stepper from "../components/Stepper";
import AvatarVideo from "../components/AvatarVideo";
import Wrapper from "../components/Wrapper";

const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/referrals.mp4" }
];

const cardStyle: CSSProperties = {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    borderRadius: '0.75rem',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    height: '12rem'
};

const flowBoxStyle: CSSProperties = {
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    border: '1px solid #e5e7eb',
    borderRadius: '1rem',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    padding: '1rem 2rem',
    textAlign: 'center',
    width: '100%',
    maxWidth: '59rem'
};

const ParentRefferals = () => {
    const [position, setPosition] = useState(0);
    // const [showModal, setShowModal] = useState(true);
    // const [videoPlaying, setVideoPlaying] = useState(false);
    // const videoRef = useRef(null);

    // const navigate = useNavigate();

    return (
        <Wrapper
            title={"Build Strong Parent Loyalty & Drive Referrals!"}
            titleSize="text-[5vh]"
            description={"Everything Done For You Automatically.No time to post? No worries!"}
            videoLinks={videoLinks}
            body={<>
            <div className="grid grid-cols-5 gap-4 mt-6">
                    <div style={{backgroundColor: "rgba(255, 255, 255, 0.4)"}} className="rounded-3xl p-4 text-[#081B34] space-y-5">
                        <h2 className="font-inter font-manropeSB text-[2.6vh]">1. Automatic Content Generation</h2>
                        <div className="text-[2.2vh] flex-grow flex flex-col">
                            <p>No social media team needed.</p>
                            <p>We create <span className="font-manropeSB">ready-to-post</span> content for your school's channels.</p>
                        </div>
                    </div>

                    <div style={{backgroundColor: "rgba(255, 255, 255, 0.4)"}} className="rounded-3xl p-4 text-[#081B34] space-y-5">
                        <h2 className="font-inter font-manropeSB text-[2.6vh]">2. Parents Become Your Ambassadors</h2>
                        <div className="text-[2.2vh] flex-grow flex flex-col">
                            <p>Engaged parents reshare posts on WhatsApp, Facebook, Instagram, <span className="font-manropeSB">expanding your reach organically</span>.</p>
                        </div>
                    </div>

                    <div style={{backgroundColor: "rgba(255, 255, 255, 0.4)"}} className="rounded-3xl p-4 text-[#081B34] space-y-5">
                        <h2 className="font-inter font-manropeSB text-[2.6vh]">3. Massive Organic <br /> Reach</h2>
                        <div className="text-[2.2vh] flex-grow flex flex-col">
                            <p>Just <span className="font-manropeSB">100 parents sharing = 25,000+ impressions</span> in your community through trusted networks.</p>
                        </div>
                    </div>

                    <div style={{backgroundColor: "rgba(255, 255, 255, 0.4)"}} className="rounded-3xl p-4 text-[#081B34] space-y-5">
                        <h2 className="font-inter font-manropeSB text-[2.6vh]">4. Leads & Interest Get Captured</h2>
                            <p className="text-[2.2vh]">From this reach, expect:</p>
                        <div className="text-[2.2vh] flex-grow flex flex-col">
                            <p>→ Website visits</p>
                            <p>→ App downloads</p>
                            <p>→ Admissions enquiries</p>
                        </div>
                    </div>

                    <div style={{backgroundColor: "rgba(255, 255, 255, 0.4)"}} className="rounded-3xl p-4 text-[#081B34] space-y-5">
                        <h2 className="font-inter font-manropeSB text-[2.6vh]">5. Higher Conversions = New Admissions</h2>
                        <div className="text-[2.2vh] flex-grow flex flex-col">
                            <p>Referral leads are <span className="font-manropeSB">8x more likely</span> to visit, call, or enroll.</p>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col items-center ">
                    <h2 className="text-smd_blue-normal font-manropeB text-[2.6vh] font-inter my-5">The Power of This Flow</h2>
                    <div style={{backgroundColor: "rgba(255, 255, 255, 0.4)"}} className="rounded-3xl py-3 px-4 text-[#081B34] space-y-1 text-center border-4 border-smd_white-light">
                        <p className="text-[2.4vh]">
                            <span className="font-manropeSB"><span className="text-[2.4vh] text-[black] font-medium tracking-wide">Just</span> 100 parents sharing your content</span> =
                            <span className="font-manropeSB"> 25,000+ views</span> →
                            <span className="font-manropeSB"> 100+ hot leads</span> →
                            <span className="font-manropeSB"> dozens of new admissions</span>
                        </p>
                        <p className="text-[2.4vh] text-[black] font-medium tracking-wide">All at zero ad cost.</p>
                    </div>
                    <p className="text-[2.2vh] mt-4 text-center">
                        This is growth that compounds, builds your brand, and keeps your admissions consistent — year after year.
                    </p>
                </div>
            </>}
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     <div className="container font-manrope p-5 flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" /></div>
        //                 <div className="text-center self-end space-y-2 col-span-8">
        //                     <h1 className="font-raveo text-smd_blue-normal text-4xl font-[1000] leading-[120%] tracking-[-1%]">Build Strong Parent Loyalty & Drive Referrals!</h1>
        //                     <p className="text-sm">Everything Done For You Automatically.No time to post? No worries!</p>
        //                 </div>
        //                 <div className="flex justify-end col-span-2">
        //                     <Img src={"/images/soomuch-demo/VideoLoader.png"} className="w-[18vh] h-[18vh] object-top object-cover rounded-lg" />
        //                 </div>
        //             </div>
        //         </div>

        //         <div className="grid grid-cols-5 gap-4 mt-6">
        //             <div style={cardStyle}>
        //                 <h2 className="font-manropeSB text-base text-center">1. Automatic Content Generation</h2>
        //                 <div className="text-sm text-center flex-grow flex flex-col items-center justify-center">
        //                     <p>No social media team needed.</p>
        //                     <p>We create <span className="font-manropeSB">ready-to-post</span> content for your school's channels.</p>
        //                 </div>
        //             </div>

        //             <div style={cardStyle}>
        //                 <h2 className="font-manropeSB text-base text-center">2. Parents Become Your Ambassadors</h2>
        //                 <div className="text-sm text-center flex-grow flex flex-col items-center justify-center">
        //                     <p>Engaged parents reshare posts on WhatsApp, Facebook, Instagram, <span className="font-manropeSB">expanding your reach organically</span>.</p>
        //                 </div>
        //             </div>

        //             <div style={cardStyle}>
        //                 <h2 className="font-manropeSB text-base text-center">3. Massive Organic Reach</h2>
        //                 <div className="text-sm text-center flex-grow flex flex-col items-center justify-center">
        //                     <p>Just <span className="font-manropeSB">100 parents sharing = 25,000+ impressions</span> in your community through trusted networks.</p>
        //                 </div>
        //             </div>

        //             <div style={cardStyle}>
        //                 <h2 className="font-manropeSB text-base text-center">4. Leads & Interest Get Captured</h2>
        //                 <div className="text-sm text-center flex-grow flex flex-col items-center justify-center">
        //                     <p>From this reach, expect:</p>
        //                     <p>→ Website visits</p>
        //                     <p>→ App downloads</p>
        //                     <p>→ Admissions enquiries</p>
        //                 </div>
        //             </div>

        //             <div style={cardStyle}>
        //                 <h2 className="font-manropeSB text-base text-center">5. Higher Conversions = New Admissions</h2>
        //                 <div className="text-sm text-center flex-grow flex flex-col items-center justify-center">
        //                     <p>Referral leads are <span className="font-manropeSB">8x more likely</span> to visit, call, or enroll.</p>
        //                 </div>
        //             </div>
        //         </div>

        //         <div className="flex flex-col items-center ">
        //             <h2 className="font-manropeSB text-lg mb-3">The Power of This Flow</h2>
        //             <div style={flowBoxStyle}>
        //                 <p className="text-base">
        //                     <span className="font-manropeSB">Just 100 parents sharing your content</span> =
        //                     <span className="font-manropeSB"> 25,000+ views</span> →
        //                     <span className="font-manropeSB"> 100+ hot leads</span> →
        //                     <span className="font-manropeSB"> dozens of new admissions</span>
        //                 </p>
        //                 <p className="text-sm text-gray-500 mt-1">All at zero ad cost.</p>
        //             </div>
        //             <p className="text-sm mt-3 text-center">
        //                 This is growth that compounds, builds your brand, and keeps your admissions consistent — year after year.
        //             </p>
        //         </div>
        //         <Stepper />
        //     </div>
        // </div>
    )
}
export default ParentRefferals;